$(document).ready(function() {
    const $serviceItems = $('.service-item');
    const $companyItems = $('.companies-item');
    const $modaleContainer = $('.modale-container');
    const $closeModaleBtn = $('.close-modale');
    let $activeServiceItem = null;

    // Hide modale by default on mobile
    if (window.innerWidth < 1440) { // md-xl breakpoint
        $modaleContainer.addClass('-translate-x-full');
    }

    $serviceItems.on({
        mouseenter: function() {
            // Skip highlighting on hover if an item is already clicked/active
            if ($activeServiceItem) return;
            
            const companies = $(this).data('companies');
            if (companies) {
                const companiesArray = companies.split(',');
                $companyItems.each(function() {
                    if (companiesArray.includes($(this).data('company'))) {
                        $(this).addClass('active');
                    }
                });
            }
            
            // Add hover effect to the service item
            $(this).addClass('hover-effect');
        },
        mouseleave: function() {
            // Skip removing highlight on mouse leave if an item is already clicked/active
            if ($activeServiceItem) return;
            
            $companyItems.removeClass('active');
            
            // Remove hover effect from the service item
            $(this).removeClass('hover-effect');
        },
        click: function() {
            const $this = $(this);
            
            // If clicking the same item that's already active, deactivate it
            if ($activeServiceItem && $activeServiceItem.is($this)) {
                $activeServiceItem = null;
                $this.removeClass('clicked');
                $this.removeClass('bg-secondary');
                $this.removeClass('hover-effect'); // Remove hover effect
                
                // Remove all active classes from companies
                $companyItems.removeClass('active');
                
                // Hide modale on mobile
                if (window.innerWidth < 1440) {
                    $modaleContainer.addClass('-translate-x-full');
                    $('body').removeClass('overflow-hidden');
                }
                
                return;
            }
            
            // Remove clicked class and hover effect from previously active item
            if ($activeServiceItem) {
                $activeServiceItem.removeClass('clicked');
                $activeServiceItem.removeClass('bg-secondary');
                $activeServiceItem.removeClass('hover-effect'); // Remove hover effect
            }
            
            // Set current service as active
            $activeServiceItem = $this;
            $this.addClass('bg-secondary');
            $this.addClass('clicked');
            $this.addClass('hover-effect'); // Add hover effect to active item
            
            // Remove all active classes first
            $companyItems.removeClass('active');
            
            // Add active class to relevant companies
            const companies = $this.data('companies');
            if (companies) {
                const companiesArray = companies.split(',');
                $companyItems.each(function() {
                    if (companiesArray.includes($(this).data('company'))) {
                        $(this).addClass('active');
                    }
                });
            }
            
            // Show modale on mobile
            if (window.innerWidth < 1440) {
                $modaleContainer.removeClass('-translate-x-full');

                // Hide overflow on body
                $('body').addClass('overflow-hidden');
            }
        }
    });
    
    // Close modale when clicking close button
    $closeModaleBtn.on('click', function() {
        $modaleContainer.addClass('-translate-x-full');
        $('body').removeClass('overflow-hidden');
        
        // Deactivate active service item
        if ($activeServiceItem) {
            $activeServiceItem.removeClass('clicked');
            $activeServiceItem.removeClass('bg-secondary');
            $activeServiceItem.removeClass('hover-effect');
            $activeServiceItem = null;
            
            // Remove all active classes from companies
            $companyItems.removeClass('active');
        }
    });
    
    // Handle window resize
    $(window).on('resize', function() {
        if (window.innerWidth >= 1440) {
            // Always show modale on desktop
            $modaleContainer.removeClass('-translate-x-full');
        } else if (!$activeServiceItem) {
            // Hide modale on mobile if no active item
            $modaleContainer.addClass('-translate-x-full');
        }
    });

    // Trigger window resize event
    $(window).trigger('resize');
});
